import { ReactNode } from 'react';

interface BusinessSettingsLayoutProps {
  children: ReactNode;
  title: string;
  description?: string;
}

/**
 * Layout wrapper for business settings pages with back button functionality
 * Provides consistent layout and navigation for all business settings pages
 */
export function BusinessSettingsLayout({ 
  children, 
  title, 
  description 
}: BusinessSettingsLayoutProps) {
  return (
    <div className="space-y-6">
      {/* Header section */}
      <div>
        <h1 className="text-3xl font-bold tracking-tight">{title}</h1>
        {description && (
          <p className="text-muted-foreground">{description}</p>
        )}
      </div>

      {/* Page content */}
      <div>{children}</div>
    </div>
  );
}
